import React from 'react';
import messages from './messages';
import { FormattedMessage } from 'react-intl';

import { fromJS } from 'immutable';
import moment from 'moment';
import isEmail from 'validator/lib/isEmail';
import numeral from 'numeral';
import { dobFormat } from 'helpers/constants';

/** HELPER */

export function getCoverages(gcConfig) {
  var coverages = [];
  gcConfig.productBenefits.mandatoryList.map(benefit => {
    if (!benefit.isComplimentary)
      coverages.push({
        type: '2',
        selected: benefit.isRequired ? true : false,
        disabled: benefit.isRequired,
        id: benefit.benefitCode,
        title: benefit.benefitName,
        value: false,
        term: 0,
        maxEntryAgeLA: benefit.maxEntryAgeLA ? benefit.maxEntryAgeLA : 0,
      });
  });

  gcConfig.productBenefits.optionalList.map(benefit => {
    coverages.push({
      type: '2',
      selected: true,
      disabled: benefit.isRequired,
      id: benefit.benefitCode,
      title: benefit.benefitName,
      value: false,
      term: 0,
      maxEntryAgeLA: benefit.maxEntryAgeLA ? benefit.maxEntryAgeLA : 0,
    });
  });
  return coverages;
}

export function calculateAgeNextBirthdate(startDate, dateOfBirth) {
  const policyStartDateYear = moment(startDate, dobFormat).format('YYYY');
  const bornYear = moment(dateOfBirth, dobFormat).format('YYYY');
  const policyStartDateMonth = moment(startDate, dobFormat).format('MM');
  const bornMonth = moment(dateOfBirth, dobFormat).format('MM');
  const policyStartDateDay = moment(startDate, dobFormat).format('DD');
  const bornDay = moment(dateOfBirth, dobFormat).format('DD');

  var monthDayPoint = 0;
  if (policyStartDateMonth == bornMonth) {
    if (policyStartDateDay >= bornDay) monthDayPoint = 0;
    else monthDayPoint = 1;
  } else if (policyStartDateMonth < bornMonth) monthDayPoint = 1;

  const anb = policyStartDateYear - bornYear - monthDayPoint + 1;
  return anb;
}

export function getMinValue(paymentFrequency, gcConfig, currency) {
  var minValue = 0;
  gcConfig.currencyPremiumSize.map(gcConfingPremium => {
    if (currency === gcConfingPremium.currency) {
      switch (paymentFrequency) {
        case 'Single':
          minValue = gcConfingPremium.minPremiumSingle;
          break;

        case 'Monthly':
          minValue = gcConfingPremium.minPremiumMonthly;
          break;

        case 'Quarterly':
          minValue = gcConfingPremium.minPremiumQuarterly;
          break;

        case 'Half-Yearly':
          minValue = gcConfingPremium.minPremiumHalfYearly;
          break;

        case 'Yearly':
          minValue = gcConfingPremium.minPremiumYearly;
          break;

        default:
          minValue = gcConfingPremium.minPremiumMonthly;
          break;
      }
    }
  });
  return minValue;
}

export function getMaxValue(paymentFrequency, gcConfig, currency) {
  var maxValue = 0;
  gcConfig.currencyPremiumSize.map(gcConfingPremium => {
    if (currency === gcConfingPremium.currency) {
      switch (paymentFrequency) {
        case 'Single':
          maxValue = gcConfingPremium.maxPremiumSingle;
          break;

        case 'Monthly':
          maxValue = gcConfingPremium.maxPremiumMonthly;
          break;

        case 'Quarterly':
          maxValue = gcConfingPremium.maxPremiumQuarterly;
          break;

        case 'Half-Yearly':
          maxValue = gcConfingPremium.maxPremiumHalfYearly;
          break;

        case 'Yearly':
          maxValue = gcConfingPremium.maxPremiumYearly;
          break;

        default:
          maxValue = gcConfingPremium.maxPremiumMonthly;
          break;
      }
    }
  });
  return maxValue;
}

export function isValidEmail(email) {
  if (email && isEmail(email)) {
    return true;
  }
  return false;
}

export function getStartDate() {
  var month = new Date().getMonth() + 1;
  if (new Date().getDate() <= 15) month = month - 1;

  return moment()
    .month(month)
    .date(1);
}

export function getMinCurrencyValue(currency, swConfig, type) {
  var minValue = 0;
  if (type === 'Premium amount') {
    swConfig.currencyPremiumSize.map(swConfigPremium => {
      if (currency === swConfigPremium.currency) {
        switch (currency) {
          case 'USD':
          case 'EUR':
          case 'GDP':
          case 'AED':
            minValue =
              swConfigPremium.minPremiumSingle ||
              swConfigPremium.minAdditionalSinglePremium;
            break;

          default:
            minValue = swConfigPremium.minPremiumSingle;
            break;
        }
      }
    });
  } else {
    swConfig.withdrawalSize.map(swConfigPremium => {
      if (currency === swConfigPremium.currency) {
        switch (currency) {
          case 'USD':
            minValue = swConfigPremium.minimumWithdrawalAmount;
            break;

          case 'EUR':
            minValue = swConfigPremium.minimumWithdrawalAmount;
            break;

          case 'GDP':
            minValue = swConfigPremium.minimumWithdrawalAmount;
            break;

          case 'AED':
            minValue = swConfigPremium.minimumWithdrawalAmount;
            break;

          default:
            minValue = swConfigPremium.minimumWithdrawalAmount;
            break;
        }
      }
    });
  }
  return minValue;
}

export function getMaxCurrencyValue(currency, swConfig) {
  var maxValue = 0;
  swConfig.currencyPremiumSize.map(swConfigPremium => {
    if (currency === swConfigPremium.currency) {
      switch (currency) {
        case 'USD':
        case 'EUR':
        case 'GDP':
        case 'AED':
          maxValue =
            swConfigPremium.maxPremiumSingle ||
            swConfigPremium.maxAdditionalSinglePremium;
          break;

        default:
          maxValue = swConfigPremium.maxPremiumSingle;
          break;
      }
    }
  });
  return maxValue;
}
